var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00518c",
    fillRule: "evenodd",
    d: "m8.43 1.598 1.983 3.928 3.816.378a.477.477 0 0 1 .296.814l-3.14 3.113 1.164 4.23a.482.482 0 0 1-.682.555L7.998 12.7l-3.863 1.913a.482.482 0 0 1-.682-.554l1.164-4.23-3.143-3.113a.477.477 0 0 1 .297-.814l3.816-.378 1.98-3.926a.485.485 0 0 1 .863 0",
    clipRule: "evenodd"
  })));
};
export default SvgLogoIcon;